module.exports = __webpack_public_path__ + "img/Icon_Report_6.50155c40.png";